import { Box } from "@mui/material";
import { ZIndex } from "@src/constants";
import Colors from "@src/constants/Colors";
import styled from "styled-components";

export const StyledRootBox = styled(Box)`
  padding: 0 16px 0px;
  background: ${Colors.white};
  height: 100%;
  z-index: ${ZIndex.LEVEL_5};
  top: 122px;
  display: flex !important;
  flex-direction: column;
  max-width: 400px !important;
  width: calc(100vw - 32px) !important;
  & .MuiList-root {
    padding: 0px !important;
  }
  & .MuiListItem-root {
    width: calc(100vw - 32px) !important;
    max-width: 400px !important;
    border-bottom: 1px solid ${Colors.neutral_gray_300};
  }
  & .MuiListItemButton-root {
    padding: 16px !important;
  }
  & .MuiTypography-root {
    font-family: "Ringside Regular-Book" !important;
    font-size: 16px !important;
    line-height: 24px !important;
    color: ${Colors.neutral_gray_900};
  }
`;

export const StyledBox = styled(Box)`
  background: ${Colors.neutral_gray_300};
  padding: 24px 16px;
  display: flex;
  align-items: center;
  position: sticky !important;
  top: 0px;
  z-index: ${ZIndex.LEVEL_4};
  & .MuiTypography-root {
    font-family: "Ringside Regular-Bold" !important;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: ${Colors.primary} !important;
  }
`;
